import { forwardRef } from "react";
import { Avatar } from "antd";
import classNames from "classnames";
import { AvatarCheckIcon } from "@/shared/icons";
import type { AvatarProps } from "antd";
import type { AvatarSize } from "./types";
import styles from "./styles.module.scss";
import { stringAvatar } from "./helpers";

type Props = {
  name: string;
  avatarSize?: AvatarSize;
  image?: string;
  person?: boolean;
  selected?: boolean;
} & AvatarProps;

export const AppAvatar = forwardRef<HTMLSpanElement, Props>(
  (
    {
      name,
      image,
      avatarSize = "small",
      person,
      className,
      selected,
      onClick = () => "",
      ...props
    },
    ref,
  ) => {
    return (
      <div className={classNames(styles.container)}>
        {selected ? (
          <AvatarCheckIcon
            onClick={() => onClick()}
            className={classNames(styles.selected, styles[`selected-${avatarSize}`])}
          />
        ) : (
          <Avatar
            onClick={onClick}
            ref={ref}
            className={classNames(
              styles.avatar,
              styles[`avatar-${avatarSize}`],
              { [styles["no-avatar"]]: !image },
              className,
            )}
            {...stringAvatar(name, image)}
            {...props}
          />
        )}
        {person ? <p>{name}</p> : ""}
      </div>
    );
  },
);
